// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","869":"styles"}[chunkId] + "." + {"245":"6f8305b0b9060a6774da","869":"8195b3196ad9d88dec60"}[chunkId] + ".css";
};